import { getUsersPerformanceAuditListQueryOptions } from "@sidegigllc/api/client";
import { adminProQueryOptions } from "api/queries/admin";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { proId: number };

export const performanceAuditQuery = ({ proId }: QueriesInput) =>
  getUsersPerformanceAuditListQueryOptions(proId, { query: { enabled: !!proId } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  adminProQueryOptions(input.proId),
  performanceAuditQuery(input),
];
